import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { USER_ROLES } from '@/constants/app';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  const getNavigationPath = (): string => {
    if (!user) return '/talky';

    switch (user.role) {
      case USER_ROLES.ADMINISTRATOR:
        return '/talky';
      case USER_ROLES.STAFF:
        return '/talky';
      case USER_ROLES.STUDENT:
        return '/profile';
      case USER_ROLES.PARENTS:
        return '/profile';
      default:
        return '/talky';
    }
  };

  if (isAuthenticated && user) {
    const params = new URLSearchParams(window.location.search);
    const returnUrl = params.get('returnUrl');
    if (returnUrl) {
      return <Navigate to={returnUrl} replace />;
    }
    return <Navigate to={getNavigationPath()} replace />;
  }

  return <>{children}</>;
};